// extracted by mini-css-extract-plugin
module.exports = {"image-container":"full_width_image_style_image-container__CUodL","image":"full_width_image_style_image__3EIl5"};